class LazyloadIframe extends HTMLIFrameElement {
  constructor (width, height) {
    const self = super(width, height)
    return self
  }

  connectedCallback () {
    new IntersectionObserver(
      (entries, observer) => {
        if (entries.length > 0 && entries[0].intersectionRatio > 0) {
          this.onVisible(observer)
        }
      }, { rootMargin: '12px' }
    ).observe(this)
  }

  onVisible (observer) {
    this.src = this.dataset.src
    delete this.dataset.src
    observer.unobserve(this)
  }
}

export default LazyloadIframe
